import styled from "styled-components"

export const CommentWrapper = styled.div``
